import { Box, ButtonGroup, Button, Typography, useTheme, useMediaQuery } from '@mui/material';
import React from 'react';
import BuyersPlan from './BuyersPlan';
import SellerPlan from './SellerPlan';
import FreePlans from './FreePlans';
import { colors, fonts } from '../../ColorFont/color';

const ManagePlans = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const tabData = [
    { label: 'Buyers Plan', component: <BuyersPlan /> },
    { label: 'Sellers Plan', component: <SellerPlan /> },
    { label: 'Free Plans', component: <FreePlans /> }
  ];

  return (
    <Box sx={{ width: '100%', px: isMobile ? 2 : 5, py: 4, bgcolor: '#fafafa', minHeight: '100vh' }}>
      {/* Header Section */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'flex-start' : 'center',
        mb: 6,
        gap: 3
      }}>
        <Box>
          <Typography sx={{
            fontFamily: fonts.poppins,
            fontSize: '2rem',
            fontWeight: 800,
            color: colors.primary_dark,
            lineHeight: 1.2
          }}>
            Plan Management
          </Typography>
          <Typography sx={{
            fontFamily: fonts.poppins,
            fontSize: '0.9rem',
            color: colors.text,
            opacity: 0.6,
            mt: 0.5
          }}>
            Configure and manage plans for users
          </Typography>
        </Box>

        <ButtonGroup
          sx={{
            bgcolor: 'rgba(0, 0, 0, 0.04)',
            p: 0.5,
            borderRadius: 4,
            '& .MuiButton-root': {
              border: 'none !important',
              borderRadius: '12px !important',
              textTransform: 'none',
              fontFamily: fonts.poppins,
              fontWeight: 600,
              px: 4,
              py: 1.2,
              color: colors.text,
              transition: 'all 0.2s ease',
              '&.active': {
                bgcolor: '#FFFFFF',
                color: colors.primary,
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              },
              '&:hover': {
                bgcolor: 'rgba(0,0,0,0.02)'
              }
            }
          }}
        >
          {tabData.map((tab, index) => (
            <Button
              key={index}
              className={activeTab === index ? 'active' : ''}
              onClick={() => handleTabChange(index)}
            >
              {tab.label}
            </Button>
          ))}
        </ButtonGroup>
      </Box>

      {/* Tab Content */}
      <Box sx={{ p: isMobile ? 2 : 3 }}>
        {tabData[activeTab].component}
      </Box>
    </Box>
  );
};

export default ManagePlans;